import { createSlice } from "@reduxjs/toolkit";
import deleteDoctorDiscountApi from "@custom/rtk-apis/billing/doctorDiscount/deleteDoctorDiscount";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const deleteDoctorDiscountSlice = createSlice({
  name: "deleteDoctorDiscountSlice",
  initialState,
  reducers: {
    cleardeleteDoctorDiscount: (state) => {
        state.status = "";
        state.result = null;
        state.msg = "";
        state.loading = false;
        state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDoctorDiscountApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteDoctorDiscountApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteDoctorDiscountApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteDoctorDiscountSlice.reducer;
export const { cleardeleteDoctorDiscount } = deleteDoctorDiscountSlice.actions;
